<template>
  <div class="report-wrap">
    <div class="slide-wrap">
      <el-menu :default-active="curComponent" class="slide-menu" @select="handleSelect">
        <el-submenu index="1">
          <template slot="title">
            <div class="menu-header">
              <svg-icon iconClass="jrtt" className="menu-icon"></svg-icon>
              <span>今日头条</span>
            </div>
          </template>
          <el-menu-item class="menu-item" index="EffectAnalysis">效果分析</el-menu-item>
          <el-menu-item class="menu-item" index="MaterialReport">素材报表</el-menu-item>
          <el-menu-item class="menu-item" index="AudienceAnalysis">受众分析</el-menu-item>
        </el-submenu>
        <el-submenu index="1">
          <template slot="title">
            <div class="menu-header">
              <svg-icon iconClass="gdt" className="menu-icon"></svg-icon>
              <span>广点通</span>
            </div>
          </template>
          <el-menu-item class="menu-item" index="MaterialReport_gdt">素材报表</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="content-wrap">
      <keep-alive>
        <component ref="curTableRef" v-bind:is="curComponent"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import EffectAnalysis from "./toutiao/effectAnalysis";
import MaterialReport from "./toutiao/materialReport";
import AudienceAnalysis from "./toutiao/audienceAnalysis";
import MaterialReport_gdt from "./gdt/materialReport";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  name: "Report",
  components: {
    EffectAnalysis,
    MaterialReport,
    AudienceAnalysis,
    MaterialReport_gdt,
    SvgIcon,
  },
  data() {
    return {
      curComponent: "EffectAnalysis",
    };
  },
  methods: {
    handleSelect(key) {
      if (this.curComponent !== key) {
        this.curComponent = key;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.report-wrap {
  display: flex;
  height: calc(100vh - 40px);
  .slide-wrap {
    flex-shrink: 0;
    width: 183px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding-top: 16px;
    .slide-menu {
      .menu-header {
        font-size: 15px;
        font-weight: bold;
        color: rgba(24, 144, 255, 1);
        .menu-icon {
          font-size: 18px;
          position: relative;
          right: 5px;
          top: 1px;
        }
      }
      .menu-item {
        min-width: 183px;
        height: 32px;
        line-height: 32px;
        margin: 4px 0;
        color: rgba(0, 0, 0, 0.64);
        font-size: 14px;
        &.is-active {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
          background: rgba(24, 144, 255, 0.1);
        }
      }
      /deep/ .el-submenu__title i {
        color: #909399;
      }
    }
  }
  .content-wrap {
    width: 100%;
  }
}
</style>
